/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from "react";
import classes from "./header.module.css";
import BottomHeader from "./bottomHeader/bottomHeaderNoAuth";
import store from "../../store/store";
import actionTypes from "../../store/actions";
import { connect } from "react-redux";

const Header = (props) => {
  useEffect(() => {
    if (!window.location.pathname.includes("confirmOrder")) {
      let id = "korewl";
      store.dispatch({ type: actionTypes.SET_TENANT_ID, id });
    }
  }, []);
  return (
    <header className={classes.header}>
      {/* <div className={'topHeaderNoAuth'} style={{ backgroundColor: props.tenantData.color }}>
                <div className={classes.innerTopHeader}>
                    <div className={classes.leftInnerTopHeader}>
                        <a href={''} target="blank" className={classes.linknorm}>{props.tenantData.title}</a>
                    </div>
                </div>
            </div> */}
      <BottomHeader />
    </header>
  );
};
const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
  };
};

export default connect(mapStateToProps)(Header);
